<template>
  <header class="header home-header">
    <div class="container">
      <div class="header-content">
        <div class="flex items-center justify-between gap-4 flex-auto">
          <NuxtLink :to="localePath('/')" class="nav-link">
            <img src="/images/logo.svg"
              width="219" height="51"
              :alt="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.title}, ${$t('global.')} 1`"
              :title="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.description}, ${$t('global.image')} 1`" />
          </NuxtLink>
          <button @click="mobileMenu?.classList.toggle('open')" class="menu-button">
            <img src="/images/icons/menu-icon.svg"
              width="24" height="24"
              :alt="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.title}, ${$t('global.')} 2`"
              :title="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.description}, ${$t('global.image')} 2`" />
          </button>
        </div>
        <div ref="mobileMenu" class="header-main">
          <div class="main-nav for-desktop">
            <NuxtLink :to="localePath('/')" class="nav-link">
              <p>{{ $t("mainNav.main") }}</p>
            </NuxtLink>
            <NuxtLink :to="localePath('/about')" class="nav-link">
              <p>{{ $t("mainNav.about") }}</p>
            </NuxtLink>
            <div class="header-add-nav new-desktop">
              <NuxtLink :to="localePath('/services')" class="nav-link">
                <p>{{ $t("mainNav.services") }}</p>
              </NuxtLink>
              <div class="add-nav">
                <NuxtLink :to="localePath('/register-bot')" class="nav-link">
                  <p class="whitespace-nowrap">{{ $t('links.registerBot') }}</p>
                </NuxtLink>
                <NuxtLink :to="localePath('/viber')" class="nav-link">
                  <p class="whitespace-nowrap">Viber</p>
                </NuxtLink>
                <NuxtLink :to="localePath('/chat')" class="nav-link">
                  <p class="whitespace-nowrap">{{ $t('services.omniChat') }}</p>
                </NuxtLink>
                <NuxtLink :to="localePath('/chathub')" class="nav-link">
                  <p class="whitespace-nowrap">{{ $t('services.chathubApi') }}</p>
                </NuxtLink>
            <NuxtLink :to="localePath('/bots-constructor')" class="nav-link">
              <p class="whitespace-nowrap">{{ $t('mainNav.botsConstructor') }}</p>
            </NuxtLink>
            <NuxtLink :to="localePath('/n8n-ai-agents')" class="nav-link">
              <p class="whitespace-nowrap">{{ $t('mainNav.n8nAiAgents') }}</p>
            </NuxtLink>
            <NuxtLink :to="localePath('/smsbat-cascade-restful-api')" class="nav-link">
              <p class="whitespace-nowrap">{{ $t('mainNav.cascadeApi') }}</p>
            </NuxtLink>
              </div>
            </div>
            <div class="header-add-nav new-desktop">
              <NuxtLink :to="localePath('/viber')" class="nav-link">
                <p>{{ $t("mainNav.viberService") }}</p>
              </NuxtLink>
              <div class="add-nav">
                <PanelMenu :model="[viberLinks[0]?.items[1]]" multiple class="mx-4 panel-menu_styled">
                  <template #item="{ item }">
                    <router-link v-if="item.route" v-slot="{ href, navigate }" :to="localePath(item.route)" custom>
                      <a v-ripple
                        class="flex items-center cursor-pointer px-3 py-2 text-gray-900 hover:bg-[rgba(93,135,255,0.1)] hover:text-[#5d87ff]"
                        :href="localePath(href)" @click="navigate">
                        <span :class="item.icon" />
                        <span class="ms-2">{{ $t(`mainNav.rates.${item.label}`) }}</span>
                        <span v-if="item.items" class="pi pi-chevron-down ms-auto"></span>
                      </a>
                    </router-link>
                    <a v-else v-ripple class="whitespace-nowrap flex items-center cursor-pointer text-color px-3 py-2"
                      :href="item.url" :target="item.target">
                      <span :class="item.icon" />
                      <span class="ms-2">{{ $t(`mainNav.viber.${item.label}`) }}</span>
                      <span v-if="item.items" class="pi pi-angle-down text-primary ms-auto" />
                    </a>
                  </template>
                </PanelMenu>
                <PanelMenu :model="[viberLinks[0]?.items[2]]" multiple class="mx-4 panel-menu_styled">
                  <template #item="{ item }">
                    <router-link v-if="item.route" v-slot="{ href, navigate }" :to="localePath(item.route)" custom>
                      <a v-ripple
                        class="flex items-center cursor-pointer px-3 py-2 text-gray-900 hover:bg-[rgba(93,135,255,0.1)] hover:text-[#5d87ff]"
                        :href="localePath(href)" @click="navigate">
                        <span :class="item.icon" />
                        <span class="ms-2">{{ $t(`mainNav.rates.${item.label}`) }}</span>
                        <span v-if="item.items" class="pi pi-chevron-down ms-auto"></span>
                      </a>
                    </router-link>
                    <a v-else v-ripple class="whitespace-nowrap flex items-center cursor-pointer text-color px-3 py-2"
                      :href="item.url" :target="item.target">
                      <span :class="item.icon" />
                      <span class="ms-2">{{ $t(`mainNav.viber.${item.label}`) }}</span>
                      <span v-if="item.items" class="pi pi-angle-down text-primary ms-auto" />
                    </a>
                  </template>
                </PanelMenu>
                <NuxtLink :to="localePath('/viber-chat-sessions')" class="nav-link ms-0 ms-2 md:ms-0">
                  <p class="whitespace-nowrap">{{ $t('mainNav.rates.chatSessions') }}</p>
                </NuxtLink>
                <NuxtLink :to="localePath('/viber-business-calls')" class="nav-link ms-0 ms-2 md:ms-0">
                  <p class="whitespace-nowrap">{{ $t('mainNav.viber.bc') }}</p>
                </NuxtLink>
              </div>
            </div>
            <div class="header-add-nav new-desktop">
              <NuxtLink :to="localePath('/sms-marketing')" class="nav-link">
                <p>{{ $t('mainNav.sms.title') }}</p>
              </NuxtLink>
              <div class="add-nav">
                <PanelMenu :model="smsLinks[0]?.items" multiple class="mx-4 panel-menu_styled">
                  <template #item="{ item }">
                    <router-link v-if="item.route" v-slot="{ href, navigate }" :to="localePath(item.route)" custom>
                      <a v-ripple
                        class="flex items-center cursor-pointer px-3 py-2 text-gray-900 hover:bg-[rgba(93,135,255,0.1)] hover:text-[#5d87ff]"
                        :href="localePath(href)" @click="navigate">
                        <span :class="item.icon" />
                        <span class="ms-2">{{ $t(`mainNav.sms.${item.label}`) }}</span>
                        <span v-if="item.items" class="pi pi-chevron-down ms-auto"></span>
                      </a>
                    </router-link>
                    <a v-else v-ripple class="whitespace-nowrap flex items-center cursor-pointer text-color px-3 py-2"
                      :href="item.url" :target="item.target">
                      <span :class="item.icon" />
                      <span class="ms-2">{{ $t(`mainNav.sms.${item.label}`) }}</span>
                      <span v-if="item.items" class="pi pi-angle-down text-primary ms-auto" />
                    </a>
                  </template>
                </PanelMenu>
              </div>
            </div>
            <div class="header-add-nav new-desktop">
              <p class="nav-link">{{ $t('mainNav.rates.title') }}</p>
              <div class="add-nav">
                <NuxtLink :to="{ path: localePath('/viber-business-messages'), hash: '#rates' }"
                  class="nav-link ms-0 ms-2 md:ms-0">
                  <p class="whitespace-nowrap">{{ $t('mainNav.rates.businessMess') }}</p>
                </NuxtLink>
                <NuxtLink :to="{ path: localePath('/viber-chat-sessions'), hash: '#rates' }"
                  class="nav-link ms-0 ms-2 md:ms-0">
                  <p class="whitespace-nowrap">{{ $t('mainNav.rates.chatSessions') }}</p>
                </NuxtLink>
                <NuxtLink :to="{ path: localePath('/viber-business-calls'), hash: '#rates' }"
                  class="nav-link ms-0 ms-2 md:ms-0">
                  <p class="whitespace-nowrap">{{ $t('mainNav.rates.businessCall') }}</p>
                </NuxtLink>
                <NuxtLink :to="{ path: localePath('/viber-chatbots'), hash: '#rates' }"
                  class="nav-link ms-0 ms-2 md:ms-0">
                  <p class="whitespace-nowrap">{{ $t('mainNav.rates.bots') }}</p>
                </NuxtLink>
              </div>
            </div>
            <NuxtLink :to="localePath('/contacts')" class="nav-link">
              <p>{{ $t("mainNav.contacts") }}</p>
            </NuxtLink>
          </div>
          <div class="header-actions for-desktop flex items-center gap-2">
            <button @click="isSearchOpen = true" class="flex items-center justify-center text-gray-500 hover:text-[#3070b6] transition-colors" title="Search Help Center">
              <i class="pi pi-search text-[22px]"></i>
            </button>
            <div class="header-lang">
              <button class="action-button">
                <img src="/images/icons/lang-icon.svg"
                  width="24" height="24"
                  :alt="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.title}, ${$t('global.')} 3`"
                  :title="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.description}, ${$t('global.image')} 3`" />
              </button>
              <div class="lang-list">
                <a v-for="l in locales" :key="l.code" :href="switchLocalePath(l.code)" @click.prevent="changeLocale(l.code)" class="lang-link cursor-pointer"
                  :class="{ active: locale == l.code }">{{ l.name }}</a>
              </div>
            </div>
            <div class="header-add-nav">
              <button class="action-button">
                <img src="/images/icons/burger-icon.svg"
                  width="24" height="24"
                  :alt="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.title}, ${$t('global.')} 4`"
                  :title="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.description}, ${$t('global.image')} 4`" />
              </button>
              <div class="add-nav">
                <NuxtLink to="https://help.smsbat.com/" external target="_blank" class="nav-link">
                  <p>{{ $t('components.header.help') }}</p>
                </NuxtLink>
                <NuxtLink to="https://developers.smsbat.com/" external target="_blank" class="nav-link">
                  <p>{{ $t('components.header.doc') }}</p>
                </NuxtLink>
                <NuxtLink :to="loginUrl" external target="_blank" class="nav-link">
                  <p>{{ $t('components.header.login') }}</p>
                </NuxtLink>
              </div>
            </div>
            <a href="https://omni.smsbat.com/" target="_blank" rel="noopener noreferrer" class="bg-[#3070b6] text-white hover:bg-blue-50 hover:text-blue-700 px-5 py-2.5 rounded-xl font-bold transition-colors shadow-sm text-[15px] hidden lg:flex items-center gap-2 ml-2 whitespace-nowrap">
              <i class="pi pi-user"></i> Sign in
            </a>
          </div>
          <div class="flex flex-col gap-2 w-full services-nav_mobile bg-white flex-auto overflow-y-auto">
            <div class="flex flex-col flex-auto gap-3 p-3">
              <NuxtLink :to="localePath('/')" class="nav-link-mobile" @click="closeMobileMenu">
                <p>{{ $t("mainNav.main") }}</p>
                <span class="pi pi-arrow-right me-3"></span>
              </NuxtLink>
              <NuxtLink :to="localePath('/about')" class="nav-link-mobile" @click="closeMobileMenu">
                <p>{{ $t("mainNav.about") }}</p>
                <span class="pi pi-arrow-right me-3"></span>
              </NuxtLink>
              <PanelMenu class="services-nav_mobile" :model="items" multiple>
                <template #item="{ item }">
                  <router-link v-if="item.route" v-slot="{ href, navigate }" :to="localePath(item.route)" custom>
                    <a v-ripple
                      class="flex items-center cursor-pointer px-3 py-2 text-gray-900 hover:bg-[rgba(93,135,255,0.1)] hover:text-[#5d87ff]"
                      :href="localePath(href)" @click="navigate">
                      <span :class="item.icon" />
                      <span class="ms-2">{{ $t(`mainNav.${item.label}`) }}</span>
                    </a>
                  </router-link>
                  <a v-else v-ripple class="flex items-center cursor-pointer text-color px-3 py-2" :href="item.url"
                    :target="item.target">
                    <span :class="item.icon" />
                    <span class="ms-2">{{ $t(`mainNav.${item.label}`) }}</span>
                    <span v-if="item.items" class="pi pi-angle-down text-primary ms-auto" />
                  </a>
                </template>
              </PanelMenu>
              <PanelMenu class="services-nav_mobile" :model="viberLinks" multiple>
                <template #item="{ item }">
                  <router-link v-if="item.route" v-slot="{ href, navigate }" :to="localePath(item.route)" custom>
                    <a v-ripple
                      class="flex items-center cursor-pointer px-3 py-2 text-gray-900 hover:bg-[rgba(93,135,255,0.1)] hover:text-[#5d87ff]"
                      :href="localePath(href)" @click="navigate">
                      <span :class="item.icon" />
                      <span class="ms-2">{{ $t(`mainNav.rates.${item.label}`) }}</span>
                      <span v-if="item.items" class="pi pi-chevron-down ms-auto"></span>
                    </a>
                  </router-link>
                  <a v-else v-ripple class="flex items-center cursor-pointer text-color px-3 py-2" :href="item.url"
                    :target="item.target">
                    <span :class="item.icon" />
                    <span class="ms-2">{{ $t(`mainNav.viber.${item.label}`) }}</span>
                    <span v-if="item.items" class="pi pi-angle-down text-primary ms-auto" />
                  </a>
                </template>
              </PanelMenu>
              <PanelMenu class="services-nav_mobile" :model="smsLinks" multiple>
                <template #item="{ item }">
                  <router-link v-if="item.route" v-slot="{ href, navigate }" :to="localePath(item.route)" custom>
                    <a v-ripple
                      class="flex items-center cursor-pointer px-3 py-2 text-gray-900 hover:bg-[rgba(93,135,255,0.1)] hover:text-[#5d87ff]"
                      :href="localePath(href)" @click="navigate">
                      <span :class="item.icon" />
                      <span class="ms-2">{{ $t(`mainNav.sms.${item.label}`) }}</span>
                      <span v-if="item.items" class="pi pi-chevron-down ms-auto"></span>
                    </a>
                  </router-link>
                  <a v-else v-ripple class="flex items-center cursor-pointer text-color px-3 py-2" :href="item.url"
                    :target="item.target">
                    <span :class="item.icon" />
                    <span class="ms-2">{{ $t(`mainNav.sms.${item.label}`) }}</span>
                    <span v-if="item.items" class="pi pi-angle-down text-primary ms-auto" />
                  </a>
                </template>
              </PanelMenu>
              <PanelMenu class="services-nav_mobile" :model="defaultRatesLinks" multiple>
                <template #item="{ item }">
                  <router-link v-if="item.route" v-slot="{ href, navigate }"
                    :to="{ path: localePath(item.route), hash: '#rates' }" custom>
                    <a v-ripple
                      class="flex items-center cursor-pointer items-center px-3 py-2 text-gray-900 hover:bg-[rgba(93,135,255,0.1)] hover:text-[#5d87ff]"
                      :href="localePath(href)" @click="navigate">
                      <span :class="item.icon" />
                      <span class="ms-2">{{ $t(`mainNav.rates.${item.label}`) }}</span>
                    </a>
                  </router-link>
                  <a v-else v-ripple class="flex items-center cursor-pointer text-color px-3 py-2" :href="item.url"
                    :target="item.target">
                    <span :class="item.icon" />
                    <span class="ms-2">{{ $t(`mainNav.rates.${item.label}`) }}</span>
                    <span v-if="item.items" class="pi pi-angle-down text-primary ms-auto" />
                  </a>
                </template>
              </PanelMenu>
              <NuxtLink :to="localePath('/contacts')" class="nav-link-mobile" @click="closeMobileMenu">
                <p>{{ $t("mainNav.contacts") }}</p>
                <span class="pi pi-arrow-right me-3"></span>
              </NuxtLink>
              <div class="header-actions justify-center mt-[10px] mb-[50px] gap-3">
                <button @click="isSearchOpen = true" class="flex items-center justify-center text-gray-500 hover:text-[#3070b6] transition-colors" title="Search Help Center">
                  <i class="pi pi-search text-[22px]"></i>
                </button>
                <div class="header-lang">
                  <button class="action-button">
                    <img src="/images/icons/lang-icon.svg"
                      width="24" height="24"
                      :alt="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.title}, ${$t('global.')} 3`"
                      :title="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.description}, ${$t('global.image')} 3`" />
                  </button>
                  <div class="lang-list">
                    <a v-for="l in locales" :key="l.code" :href="switchLocalePath(l.code)" @click.prevent="changeLocale(l.code)" class="lang-link cursor-pointer"
                      :class="{ active: locale == l.code }">{{ l.name }}</a>
                  </div>
                </div>
                <div class="header-add-nav">
                  <button class="action-button">
                    <img src="/images/icons/burger-icon.svg"
                      width="24" height="24"
                      :alt="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.title}, ${$t('global.')} 4`"
                      :title="`${pagesSeo.find(el => route.path.includes(el.route))?.seo.layout.description}, ${$t('global.image')} 4`" />
                  </button>
                  <div class="add-nav">
                    <NuxtLink to="https://help.smsbat.com/" external target="_blank" class="nav-link">
                      <p>{{ $t('components.header.help') }}</p>
                    </NuxtLink>
                    <NuxtLink to="https://developers.smsbat.com/" external target="_blank" class="nav-link">
                      <p>{{ $t('components.header.doc') }}</p>
                    </NuxtLink>
                    <NuxtLink :to="loginUrl" external target="_blank" class="nav-link">
                      <p>{{ $t('components.header.login') }}</p>
                    </NuxtLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Search Overlay Form -->
    <div v-if="isSearchOpen" class="fixed inset-0 z-[9999] flex items-start justify-center pt-24 bg-black/50 backdrop-blur-sm transition-opacity" @click.self="isSearchOpen = false">
      <div class="bg-white w-[90%] max-w-4xl rounded-xl shadow-2xl border border-gray-200 p-2 flex items-center gap-3 animate-fade-in-down" @click.stop>
        <i class="pi pi-search text-gray-400 text-2xl ml-3"></i>
        <input 
          v-model="searchQuery" 
          @keyup.enter="onSearchHelp" 
          @keydown.esc="isSearchOpen = false"
          ref="searchInputRef"
          type="text" 
          :placeholder="($t('global.search') || 'Search') + '...'" 
          class="flex-1 text-xl outline-none border-none py-3 bg-transparent text-gray-700"
        />
        <button @click="isSearchOpen = false" class="p-3 hover:bg-gray-100 rounded-lg transition-colors mr-1">
          <i class="pi pi-times text-gray-500 text-xl"></i>
        </button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
const localePath = useLocalePath();
const switchLocalePath = useSwitchLocalePath();
const { locale, setLocale, t, locales } = useI18n();
const { loadPagesForSeo } = useSeoStore()
const route = useRoute()
const router = useRouter()

const { pagesSeo } = storeToRefs(useSeoStore())

const mobileMenu = ref();

// Search logic
const isSearchOpen = ref(false);
const searchQuery = ref('');
const searchInputRef = ref<HTMLInputElement | null>(null);

watch(isSearchOpen, async (val) => {
  if (val) {
    searchQuery.value = '';
    closeMobileMenu();
    await nextTick();
    searchInputRef.value?.focus();
  }
});

const onSearchHelp = () => {
  if (!searchQuery.value.trim()) return;
  let helpLangPath = '';
  const currentLangIso = locales.value.find(l => (l as any).code === locale.value)?.iso || 'en';
  
  if (currentLangIso !== 'en') {
      helpLangPath = `/${currentLangIso.toLowerCase()}`;
  }
  
  const searchUrl = `https://help.smsbat.com${helpLangPath}/?q=${encodeURIComponent(searchQuery.value.trim())}`;
  window.open(searchUrl, '_blank');
  
  isSearchOpen.value = false;
  searchQuery.value = '';
};

const loginUrl = computed(() => {
  if (locale.value == 'uk-ua') return 'https://omni.smsbat.com/ua/auth/login'
  return 'https://omni.smsbat.com/auth/login'
})

const items = ref([
  {
    label: 'services',
    items: [
      {
        label: 'serviceMain',
        route: '/services',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/services'));
        }
      },
      {
        label: 'registerBot',
        route: '/register-bot',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/register-bot'));
        }
      },
      {
        label: 'viberService',
        route: '/viber',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/viber'));
        }
      },
      {
        label: 'chatService',
        route: '/chat',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/chat'));
        }
      },
      {
        label: 'chathubApi',
        route: '/chathub',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/chathub'));
        }
      },
        {
          label: 'botsConstructor',
          route: '/bots-constructor',
          command: () => {
            closeMobileMenu()
            router.push(localePath('/bots-constructor'));
          }
        },
        {
          label: 'n8nAiAgents',
          route: '/n8n-ai-agents',
          command: () => {
            closeMobileMenu()
            router.push(localePath('/n8n-ai-agents'));
          }
        },
        {
          label: 'cascadeApi',
          route: '/smsbat-cascade-restful-api',
          command: () => {
            closeMobileMenu()
            router.push(localePath('/smsbat-cascade-restful-api'));
          }
        }
    ]
  }
]);

const viberLinks = ref([
  {
    label: 'title',
    items: [
      {
        label: 'viberBusiness',
        route: '/viber',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/viber'));
        }
      },
      {
        label: 'businessMess',
        items: [
          {
            label: 'main',
            route: '/viber-business-messages',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/viber-business-messages'));
            },
          },
          {
            label: 'viberTransactional',
            route: '/viber-transactional-messages',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/viber-transactional-messages'));
            }
          },
          {
            label: 'viberOtp',
            route: '/viber-otp',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/viber-otp'));
            }
          },
          {
            label: 'viberCarousel',
            route: '/viber-carousel',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/viber-carousel'));
            }
          },
          {
            label: 'viberSurvey',
            route: '/viber-survey',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/viber-survey'));
            }
          },
            {
                label: 'customAutoReply',
                route: '/viber-business-messages-custom-auto-reply',
                command: () => {
                    closeMobileMenu()
                    router.push(localePath('/viber-business-messages-custom-auto-reply'));
                }
            }
        ]
      },
      {
        label: 'bots',
        items: [
          {
            label: 'botsMain',
            route: '/viber-chatbots',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/viber-chatbots'));
            }
          },
          {
            label: 'registerBotToken',
            route: '/register-bot',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/register-bot'));
            }
          },
          {
            label: 'botVerification',
            route: '/viber-bot-verification',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/viber-bot-verification'));
            }
          },
          {
            label: 'sessionCounter',
            route: '/session-counter',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/session-counter'));
            }
          },
          {
            label: 'botPromotion',
            route: '/viber-bot-promotion',
            command: () => {
              closeMobileMenu()
              router.push(localePath('/viber-bot-promotion'));
            }
          }
        ]
      },
      {
        label: 'businessCall',
        route: '/viber-business-calls',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/viber-business-calls'));
        }
      }
    ]
  }
]);

const smsLinks = ref([
  {
    label: 'title',
    items: [
      {
        label: 'marketing',
        route: '/sms-marketing',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/sms-marketing'));
        }
      },
      {
        label: 'alerts',
        route: '/sms-alert-notifications',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/sms-alert-notifications'));
        }
      },
      {
        label: 'twoFactor',
        route: '/two-factor-authentication',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/two-factor-authentication'));
        }
      },
      {
        label: 'gateway',
        route: '/sms-gateway',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/sms-gateway'));
        }
      }
    ]
  }
]);
const defaultRatesLinks = ref([
  {
    label: 'title',
    items: [
      {
        label: 'businessMess',
        route: '/viber-business-messages',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/viber-business-messages#rates'));
        }
      },
      {
        label: 'businessCall',
        route: '/viber-business-calls',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/viber-business-calls#rates'));
        }
      },
      {
        label: 'bots',
        route: '/viber-chatbots',
        command: () => {
          closeMobileMenu()
          router.push(localePath('/viber-chatbots#rates'));
        }
      }
    ]
  }
]);

const changeLocale = async (locale: string) => {
  await setLocale(locale as any);
  loadPagesForSeo();
}

const closeMobileMenu = () => {
  mobileMenu.value?.classList.remove('open')
}

</script>

<style lang="scss">
.header .pi {
  height: min-content;
}

.header-add-nav.new-desktop {
  display: none !important;
}

.for-desktop {
  display: none !important;
}

.services-nav_mobile .p-panelmenu-panel {
  margin-bottom: 0;
}

.services-nav_mobile .p-panelmenu-header-content {
  border: none !important;

  & a {
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 4px;
    color: rgb(89, 88, 90);
    font-size: 16px;
    font-weight: 600;

    & svg {
      margin-left: 5px;
      margin-right: 0;
    }
  }
}

.services-nav_mobile .p-panelmenu-content {
  border: none !important;

  & a {
    justify-content: center;
    text-align: center;
  }

  & a span {
    margin-left: 0;
  }
}

.panel-menu_styled {
  margin-bottom: 5px;

  * {
    color: #59585a;
    font-weight: 600;
  }

  div {
    border: none;
  }

  a {
    padding: 0;

    span:nth-child(2) {
      margin-left: 3px;
    }

    span:last-child {
      margin-left: 10px;
    }
  }
}

@media (min-width: 992px) {
  .for-desktop {
    display: flex !important;
  }

  .header-add-nav.new-desktop {
    display: flex !important;
  }

  .services-nav_mobile {
    display: none !important;
    border: none !important;

    & .p-panelmenu-header-content {
      border: none !important;
      background-color: saddlebrown !important;
    }
  }

  .p-panelmenu-header-content {
    border: none !important;
    background-color: saddlebrown !important;
  }
}
</style>